import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
Wrapper.displayName = 'Wrapper';

export const DataContainer = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  gap: 13px;
`;
DataContainer.displayName = 'DataContainer';
